import axios from 'axios';
import { connection } from './connection';
import {EnquiryAssessmentResponseModel,EnquiryAssessmentInfoReq, EnquiryAssessmentUpdateReq, EnquirymanagementReq, getAllEnquiryInfoReq, EnQuiryManagementResponse, EnquiryAssessmentInfoModel, enquiryInfo, EnquiryIdreq, FreezeUnFreezeInfoReq} from '@gtpl/shared-models/enquiry-management'
import { CommonResponse } from '@gtpl/shared-models/masters';

export class EnquiriesService {
      URL = connection.DEPLOY_URL + '/enquiries';

    async getAllEnquiriesByStatus(request: EnquiryAssessmentInfoReq): Promise<EnquiryAssessmentResponseModel> {
        return await axios.post(this.URL + '/getAllEnquiriesByStatus', request)
            .then(res => {
                return res.data
            })
    }

    async updateEnquiryAssesmentStatus(request: EnquiryAssessmentUpdateReq): Promise<EnquiryAssessmentResponseModel> {
        return await axios.post(this.URL + '/updateEnquiryAssesmentStatus', request)
            .then(res => {
                return res.data
            })
    }
    async createEnquiry(req:EnquirymanagementReq):Promise<CommonResponse>{
        console.log(req)
        return await axios.post(this.URL + '/createEnquiry',req)
        .then(res =>{
            return res.data
        })
    }
    async updateEnquiry(req:EnquirymanagementReq):Promise<CommonResponse>{
        // console.log(req)
        return await axios.post(this.URL + '/updateEnquiry',req)
        .then(res =>{
            return res.data
        })
    }

    async getEnquiryNumberDropdown(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getEnquiryNumberDropdown')
            .then(res => {
                return res.data
            })
    }

    async getEnquiryDropdownForEnquiryAssessment(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getEnquiryDropdownForEnquiryAssessment')
            .then(res => {
                return res.data
            })
    }

    async getCostSheetEnquiryNumberDropdown(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getCostSheetEnquiryNumberDropdown')
            .then(res => {
                return res.data
            })
    }

    async getCountryDropdown(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getCountryDropdown')
            .then(res => {
                return res.data
            })
    }

    async getDestinationDropdown(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getDestinationDropdown')
            .then(res => {
                return res.data
            })
    }

    async getUnitDropdown(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getUnitDropdown')
            .then(res => {
                return res.data
            })
    }

    async getEnquiryById(req:EnquiryIdreq): Promise<EnQuiryManagementResponse> {
        return await axios.post(this.URL + '/getEnquiryById',req)
            .then(res => {
                return res.data
            })
        }
    async getAllEnquiriesInfo(req:getAllEnquiryInfoReq):Promise<EnQuiryManagementResponse>{
        return await axios.post(this.URL + '/getAllEnquiriesInfo',req)
        .then(res =>{
            return res.data
        })
    }

    async cancelEnquiry(req:EnquiryAssessmentInfoModel):Promise<EnquiryAssessmentResponseModel>{
        return await axios.post(this.URL + '/cancelEnquiry',req)
        .then(res =>{
            return res.data
        })
    }

    async getCountPricesInfo():Promise<CommonResponse>{
        return await axios.post(this.URL + '/getCountPricesInfo')
        .then(res =>{
            return res.data
        })
    }

    async getAllEnquiryDetailsById(req: EnquiryIdreq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllEnquiryDetailsById',req)
        .then(res =>{
            return res.data
        })
    }

    async getLeadProductInfoModelByEnquiryId(req: EnquiryIdreq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getLeadProductInfoModelByEnquiryId',req)
        .then(res =>{
            return res.data
        })
    }

    async getEnqProductConfirmedContainersInfo(req: EnquiryIdreq):Promise<any>{
        return await axios.post(this.URL + '/getEnqProductConfirmedContainersInfo',req)
        .then(res =>{
            return res.data
        })
    }

    async updateProductSoCreationStatus(req: EnquiryIdreq):Promise<any>{
        return await axios.post(this.URL + '/updateProductSoCreationStatus',req)
        .then(res =>{
            return res.data
        })
    }

    async getFreezeUnFreezeEnquiryNumberDropdown(req:FreezeUnFreezeInfoReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getFreezeUnFreezeEnquiryNumberDropdown',req)
            .then(res => {
                return res.data
            })
    }
}